import { Link } from 'react-router'

export default function ParadeIndex() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Parade
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<Link
						to="/events/2025-car-show-and-parade/"
						className="mt-3 flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-2xl font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
					>
						View Car Show Details
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="ml-2 -mr-0.5 h-4 w-4"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</Link>

					<img
						src="/images/ebhs/events/2025-parade-poster.jpg"
						alt="poster for 2025 car show"
						className="w-full py-3"
					/>

					<Link
						to="/events/2025-car-show-and-parade/"
						className="flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-2xl font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
					>
						View Car Show Details
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="ml-2 -mr-0.5 h-4 w-4"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</Link>
				</div>
			</div>
		</>
	)
}
